import script from "./CertificationUpdatesTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationUpdatesTile.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/certification-updates/base.css?vue&type=style&index=0&id=c388f2bc&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c388f2bc"]])

export default __exports__